<script setup>
import {defineProps} from 'vue';

const props = defineProps({
    navigation: Array,
});
</script>
<template>
    <nav class="hidden lg:py-2 lg:flex lg:space-x-8" aria-label="Global">
        <span v-for="item in props.navigation" :key="item.name">
            <!-- Use router-link for internal links -->
            <router-link
                v-if="!item.external"
                :key="item.name"
                :to="item.href"
                :class="[
                    item.current ? 'bg-gray-100 text-blue-400' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900',
                    'rounded-md py-2 px-3 inline-flex items-center text-sm font-medium',
                ]"
                :aria-current="item.current ? 'page' : undefined"
            >
                {{ $tt(item.name).toUpperCase() }}
            </router-link>

            <!-- Use regular anchor tag for external links -->
            <a
                v-if="item.external"
                :href="item.href"
                target="_blank" rel="noopener noreferrer"
                :class="[
                    'text-gray-500 hover:bg-gray-50 hover:text-gray-900',
                    'rounded-md py-2 px-3 inline-flex items-center text-sm font-medium',
                ]"
            >
                {{ $tt(item.name).toUpperCase() }}
            </a>
        </span>
    </nav>
</template>

